<template>
    <div :style="`min-width:${barChartGroupSize.chartData.labels.length * 8}px;max-width:100%;`">
        <bar-chart id="pie-chart-size" :height="height" :chart-data="barChartGroupSize.chartData" :extra-options="barChartGroupSize.extraOptions"></bar-chart>
    </div>
</template>

<script>
import BarChart from '@/components/Charts/BarChart'
import defaultChartObjects from '../defaultChartObjects';
import { mapActions, mapGetters } from 'vuex'

export default {
    component: 'BarChartTamanho',

    components: {
        BarChart,
    },

    props: {
        height: {
            type: Number,
            default: 250
        },

        colors: {
            type: Array,
            default: []
        },

        fetchProgress: {
            type: Number,
            default: 0 | 100
        },

        tableData: {
            type: Array,
            default: [],
        },

        clientsCountItemName: {
            type: String,
            default: "itens",
        },

        defaultBarThickness: {
            type: Number,
            default: 8,
        },

        plurals: {
            type: Object,
            default: {},
        },

        billName: {
            type: String,
            default: 'bill',
        },

        selectedbillItensNames: {
            type: Array | Object,
            default: [] | {},
        },
    },

    data: () => {
        return {
            maxBarThickness: 30, //defaultChart: defaultObject,
        }
    },

    methods: {
        ...mapActions('product',[
            "productStoreCommit",
        ]),

        //METHOD TO GROUP BY KEYGETTER.
        //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
        groupBy(list, keyGetter) {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);
                if (!collection) { map.set(key, [item]); }
                else { collection.push(item); }
            });
            return Array.from(map);
        },

        plural(term) {
            term = term.toLowerCase()
            let convertedIndex = Object.keys(this.plurals).indexOf(term)
            let convertedTerm = ''

            if (convertedIndex >= 0) { convertedTerm = Object.values(this.plurals)[convertedIndex] }
            else {
                convertedIndex = Object.values(this.plurals).indexOf(term)
                convertedTerm = Object.keys(this.plurals)[convertedIndex]
            }
            return convertedTerm
        },
    },

    computed: {
        ...mapGetters('product', {
            useChartCache: "getUseChartCache",
            cacheObject: "getBarChartTamanho",
        }),

        monthNamesAbr() { return ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'] },

        barChartGroupSize() {

            var defaultChart = {}
            defaultChart = JSON.parse(JSON.stringify(defaultChartObjects.defaultBarChartTamanho))

            if(this.useChartCache && this.cacheObject.chartData != undefined && this.cacheObject.chartData.labels.length > 0){

              defaultChart = JSON.parse(JSON.stringify(this.cacheObject))
            }

            if(this.fetchProgress < 100){
              sessionStorage.removeItem('SET_BAR_CHART_TAMANHO_save')
            }

            if((this.fetchProgress == 100)){

                var _billName = this.billName
                var _clientsCountItemName = this.clientsCountItemName
                const vm = this
                var filteredTableData = []
                var labels = Array.from({ length: 8 }, (el, idx) => ({ label: idx + 1, count: 0, size: 0 }))

                filteredTableData = Object.values(this.tableData)

                var dados = filteredTableData.filter(el => ((el.trafx == null || el.trafx == undefined || el.trafx == false) && (el.finance == null || el.finance == undefined || el.finance == false) ))
                dados = this.groupBy(dados, el => { return el.people.tableText.count })

                var dadosTrafx = filteredTableData.filter(el => el.trafx)
                dadosTrafx = this.groupBy(dadosTrafx, el => { return el.people.tableText.count })

                var dadosFinance = filteredTableData.filter(el => el.finance)
                dadosFinance = this.groupBy(dadosFinance, el => { return el.people.tableText.count })

                // [0] => N visitantes (index), [1] => N grupos de [0] visitantes (value)
                dadosTrafx.map(function(val, idx){
                    const len = val[1].length
                    val[1] = len
                })

                dadosFinance.map(function(val, idx){
                    const len = val[1].length
                    val[1] = len
                })

                dados.map(function (val) {
                    let groupSize = val[0]
                    if (groupSize > 7) { groupSize = ((Math.ceil(groupSize / 7) + 6)) }

                    if (groupSize > 0) {
                        let idx = groupSize - 1
                        if (labels[idx] == undefined) { labels[idx] = { label: 0, count: 0, size: 0 } }

                        labels[idx]['label'] = Number(groupSize)
                        labels[idx]['count'] += val[1].reduce((total, val) => { return total + val.people.tableText.count / 1 }, 0)
                        labels[idx]['size'] += val[1].length
                    }
                })

                let formattedLabels = Array.from({ length: labels.length }, (el, idx) => ({ label: idx + 1, count: 0, size: 0 }))
                labels.forEach((el) => { if (undefined != el) { formattedLabels[el.label - 1] = el } })
                labels = formattedLabels

                formattedLabels = labels.map(function (val, idx) {
                    if (val.label / 1 == 1) { return val.label + ' ' + vm.plural(_clientsCountItemName) }
                    else {
                        if (val.label > 7) {
                            let label = ((val.label - 7) * 7) + 1
                            return `${label} a ${label + 6} ${_clientsCountItemName}`
                        }
                        else { return val.label + ' ' + _clientsCountItemName }
                    }
                })

                let trafx_data = new Array(formattedLabels.length).fill(0)
                let finance_data = new Array(formattedLabels.length).fill(0)

                dadosTrafx.map(function(value, index){
                    const num_grupos = value[0]
                    const num_visitantes = value[1]
                    var trafxIndex = 0
                    let chart_label = ''

                    if(num_visitantes <= 7){
                        chart_label = num_visitantes == 1 ? num_visitantes + ' visitante' : num_visitantes + ' ' + _clientsCountItemName
                    }
                    else if(num_visitantes > 7){
                        trafxIndex = formattedLabels.findIndex(function(intervalo, i){              // FIND WHERE THE NUM_VISITANTES INDEX IS BETWEEN THE LABELS
                            const [inicio, fim] = intervalo.match(/\d+/g).map(Number);
                            if (num_visitantes >= inicio && num_visitantes <= fim) {
                                chart_label = `${inicio} a ${fim} ${_clientsCountItemName}`
                                return chart_label
                            }
                        })
                    }

                    trafxIndex = formattedLabels.findIndex(i => i === chart_label);
                    if(trafxIndex < 0){
                        formattedLabels.push(chart_label).sort()
                        trafxIndex = formattedLabels.findIndex(i => i === chart_label);
                    }
                    trafx_data[trafxIndex] += num_grupos
                })

                dadosFinance.map(function(value, index){
                    const num_grupos = value[0]
                    const num_visitantes = value[1]
                    var financeIndex = 0
                    let chart_label = ''

                    if(num_visitantes <= 7){
                        chart_label = num_visitantes == 1 ? num_visitantes + ' visitante' : num_visitantes + ' ' + _clientsCountItemName
                    }
                    else if(num_visitantes > 7){
                        financeIndex = formattedLabels.findIndex(function(intervalo, i){              // FIND WHERE THE NUM_VISITANTES INDEX IS BETWEEN THE LABELS
                            const [inicio, fim] = intervalo.match(/\d+/g).map(Number);
                            if (num_visitantes >= inicio && num_visitantes <= fim) {
                                chart_label = `${inicio} a ${fim} ${_clientsCountItemName}`
                                return chart_label
                            }
                        })
                    }

                    if(chart_label.length > 0){
                        financeIndex = formattedLabels.findIndex(i => i === chart_label);
                        if(financeIndex < 0){
                            formattedLabels.push(chart_label).sort()
                            financeIndex = formattedLabels.findIndex(i => i === chart_label);
                        }
                        finance_data[financeIndex] += num_grupos
                    }
                })

                defaultChart.chartData = {
                    labels: formattedLabels,
                    datasets: [
                        {
                            data: labels.map(function (val, idx) { return val.size }),
                            backgroundColor: this.colors[0],
                            groupCount: labels,
                            barThickness: this.defaultBarThickness,
                            maxBarThickness: this.maxBarThickness,
                            yAxisID: 'A',
                        },
                        {
                            data: trafx_data,
                            backgroundColor: this.colors[1],
                            groupCount: labels,
                            barThickness: this.defaultBarThickness,
                            maxBarThickness: this.maxBarThickness,
                            yAxisID: 'A',
                        },
                        {
                            data: finance_data,
                            backgroundColor: this.colors[3],
                            groupCount: labels,
                            barThickness: this.defaultBarThickness,
                            maxBarThickness: this.maxBarThickness,
                            yAxisID: 'A',
                        },
                    ],
                }

                defaultChart.extraOptions = {
                    legend: { display: false, },
                    animation: false,
                    transitions: {
                        ative: {
                            animation: {
                                duration: 0,
                            }
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {
                                // BILLS PERSONs COUNT TOOLTIP
                                if(tooltipItem.datasetIndex == 0){
                                    return tooltipItem.value + ' ' + _billName + ' - ' + (data.datasets[0]['groupCount'][tooltipItem.index]['count']) +
                                        ' ' + _clientsCountItemName;
                                }

                                // TRAFX TOOLTIP
                                if(tooltipItem.datasetIndex == 1){
                                    const trafx_counts = (labels[tooltipItem.index].label * tooltipItem.value)
                                    return `${Number(tooltipItem.value)} grupos Trafx - ` + trafx_counts + ` registros`
                                }

                                // FINANCE TOOLTIP
                                if(tooltipItem.datasetIndex == 2){
                                    const trafx_counts = (labels[tooltipItem.index].label * tooltipItem.value)
                                    return `${Number(tooltipItem.value)} grupos Financeiro - ` + trafx_counts + ` entradas financeiras`
                                }
                            }
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'A',
                                type: 'linear',
                                position: 'left',
                                title: 'Qntd.',
                                barPercentage: 0.3,
                            },
                        ],
                    },
                }

                if (this.useChartCache == true && this.fetchProgress == 100 && !sessionStorage.getItem('SET_BAR_CHART_TAMANHO_save')) {
                  sessionStorage.setItem('SET_BAR_CHART_TAMANHO_save','true')

                  this.productStoreCommit({ mutation:"SET_BAR_CHART_TAMANHO", value: JSON.parse(JSON.stringify(defaultChart)) })
                }
            }

            return defaultChart
        },
    },
}

</script>
